import Layout from "@components/Layout"
import RadioInputButton from "@components/RadioInputButton"
import { useTranslation } from "react-i18next"
import { Form, useSubmit } from "react-router-dom"

export default function HabitConsistencyPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    submit(event.currentTarget.form)
  }

  return (
    <Layout>
      <div className="shrink-0">
        <h1 className="custom-heading">
          {t("pages.onboardingV2.habitConsistency.heading")}
        </h1>
      </div>

      <Form className="flex grow flex-col justify-center gap-5" method="post">
        <RadioInputButton
          className="from-pd-yellow"
          emoji="🔁"
          label={t("pages.onboardingV2.habitConsistency.always")}
          name={t("pages.onboardingV2.habitConsistency.heading", {
            lng: "en",
          })}
          onChange={handleChange}
          value={t("pages.onboardingV2.habitConsistency.always", {
            lng: "en",
          })}
        />

        <RadioInputButton
          className="from-pd-peach"
          emoji="⚖️"
          label={t("pages.onboardingV2.habitConsistency.sometimes")}
          name={t("pages.onboardingV2.habitConsistency.heading", {
            lng: "en",
          })}
          onChange={handleChange}
          value={t("pages.onboardingV2.habitConsistency.sometimes", {
            lng: "en",
          })}
        />

        <RadioInputButton
          className="from-pd-purple"
          emoji="💪"
          label={t("pages.onboardingV2.habitConsistency.rarely")}
          name={t("pages.onboardingV2.habitConsistency.heading", {
            lng: "en",
          })}
          onChange={handleChange}
          value={t("pages.onboardingV2.habitConsistency.rarely", {
            lng: "en",
          })}
        />
      </Form>
    </Layout>
  )
}
